import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const fcProxyPost = t.type({
  fc_api: t.string,
  use_original: t.boolean,
  status_code: t.number,
  content: t.type({}),
});

export type FCProxyPost = t.TypeOf<typeof fcProxyPost>;

export const fcProxy = t.type({
  ...fcProxyPost.props,
  status_code: h.omittable(t.number),
});
